// import dayjs from 'dayjs'
// import Weekday from 'dayjs/plugin/weekday'
// import localeData from 'dayjs/plugin/localeData'

// // import updateLocale from 'dayjs/plugin/updateLocale'
// import localizedFormat from 'dayjs/plugin/localizedFormat'
// import customParseFormat from 'dayjs/plugin/customParseFormat'
// import dayOfYear from 'dayjs/plugin/dayOfYear'
// import weekOfYear from 'dayjs/plugin/weekOfYear'

// import isToday from 'dayjs/plugin/isToday'
// import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
// import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

// // import relativeTime from 'dayjs/plugin/relativeTime';
// // import Timezone from 'dayjs/plugin/timezone';
// // import Utc from 'dayjs/plugin/utc';

// import 'dayjs/locale/es'
// import 'dayjs/locale/en'
// import 'dayjs/locale/en-gb'
// import 'dayjs/locale/de'
// import 'dayjs/locale/fr'

// import { computedWithControl } from '@vueuse/core'

// dayjs.extend(Weekday)
// dayjs.extend(localeData)
// // dayjs.extend(updateLocale)
// dayjs.extend(localizedFormat)
// dayjs.extend(customParseFormat)
// dayjs.extend(dayOfYear)
// dayjs.extend(weekOfYear)

// dayjs.extend(isToday)
// dayjs.extend(isSameOrBefore)
// dayjs.extend(isSameOrAfter)

// export function useDayjs() {
//   const { locale } = useLocale()
//   watch(locale, () => {
//     dayjs.locale(locale.value)
//   })
//   const computedDayjs = computedWithControl(
//     () => locale.value,
//     () => dayjs,
//   )
//   return computedDayjs
// }

import { useDayjs as useDsDayjs } from '@daysmart/daysmart-vue-components/composables'

export function useDayjs() {
  return useDsDayjs()
}
